import React from "react";
import SwaggerUIReact from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { Loading } from "./loading";

export interface SwaggerRequest {
  [k: string]: unknown;
  headers?: Record<string, string>;
}

// Cast to avoid React type version mismatch between @types/swagger-ui-react and project React types
const SwaggerUI = SwaggerUIReact as React.ComponentType<{
  url: string;
  requestInterceptor?: (req: SwaggerRequest) => SwaggerRequest;
  filter?: boolean;
  docExpansion?: string;
  persistAuthorization?: boolean;
}>;

interface SwaggerUIWrapperProps {
  url: string;
  requestInterceptor: (req: SwaggerRequest) => SwaggerRequest;
  token?: string;
}

/**
 * Wrapper component for SwaggerUI that handles token-based authentication.
 * Note: swagger-ui-react only supports `url` prop, not `urls` array.
 *
 * Token refresh is handled via ref in the parent component's requestInterceptor,
 * so SwaggerUI doesn't need to re-mount when tokens refresh - preserving UI state.
 */
export const SwaggerUIWrapper: React.FC<SwaggerUIWrapperProps> = ({
  url,
  requestInterceptor,
  token,
}) => {
  if (!token) {
    return <Loading />;
  }

  // Only use url as key - token changes are handled by requestInterceptor ref
  // This preserves SwaggerUI state (expanded endpoints, form data) on token refresh
  return (
    <SwaggerUI
      key={url}
      url={url}
      requestInterceptor={requestInterceptor}
      filter={true}
      docExpansion="list"
      persistAuthorization={true}
    />
  );
};
